import { Theme } from '@afterpaytouch/core'
import { Country } from '@afterpaytouch/portal-api/types'

export const THEME_COOKIE_NAME = 'x-apt-theme'

export enum ConvergenceUnavailable {
  Disabled = 'Disabled',
  DisabledWithOverride = 'DisabledWithOverride',
}

export enum ConvergenceAvailable {
  Enabled = 'Enabled',
}

export type ConvergenceRollout = ConvergenceAvailable | ConvergenceUnavailable

export interface SetThemeRequest {
  theme: Theme
}

export const DEFAULT_THEME = Theme.AP

export const ConvergenceCountryTheme: Record<Country, Theme> = {
  [Country.AU]: Theme.AP,
  [Country.CA]: Theme.AP,
  [Country.ES]: Theme.AP,
  [Country.FR]: Theme.AP,
  [Country.GB]: Theme.AP,
  [Country.IT]: Theme.AP,
  [Country.NZ]: Theme.AP,
  [Country.US]: Theme.Cash,
}

export const APT_USER_ID = 'apt-user-id'
export const APT_USER_COUNTRY = 'apt-user-country'

// static array of enabled countries, to prevent re-renders on creating a new array in the function
const PORTAL_MIGRATION_ENABLED_COUNTRIES: Country[] = [Country.CA, Country.US, Country.AU]

/**
 * Determines which countries are enabled for portal migration.
 *
 * This function returns a list of countries where portal migration is enabled.
 * The enabled countries are Canada (CA), United States (US), and Australia (AU).
 *
 * @returns {Country[]} Array of countries where portal migration is enabled
 *
 * @example
 * ```typescript
 * const enabledCountries = getPortalMigrationEnabledCountry()
 * // Returns: [Country.CA, Country.US, Country.AU]
 * ```
 */
export const getPortalMigrationEnabledCountry = (): Country[] => {
  return PORTAL_MIGRATION_ENABLED_COUNTRIES
}
